/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {Text} from 'react-native';
import {InputError} from '../../../../data/types/interface/input';
import styles from '../styles';
import { MESSAGE_VALIDATION } from '../../../../common/utils/validation';

interface Props {
  label: string;
  required?: boolean;
  callBack?: any;
  defaultValue?: Date;
  requiredField?: boolean;
  isScolaire?: boolean;
  minAge?: number;
  maxAge?: number;
}

export const DateTimePickerWeb = ({
  label,
  required,
  callBack,
  defaultValue,
  requiredField,
  isScolaire,
  minAge,
  maxAge,
}: Props) => {
  const [startDate, setStartDate] = useState(defaultValue);
  const [, setIsFocus] = useState(requiredField);
  const _minAge = minAge ? minAge : 18;
  const _maxAge = maxAge ? maxAge : 60;
  const [error] = useState<InputError>({message: '', exist: false});
  if (!startDate) {
    error.exist = true;
    error.message = MESSAGE_VALIDATION.requiredField;
  }
  return (
    <div
      className={requiredField && error.exist ? 'inputError' : 'datetimeCss'}>
      {label && (
        <label className={'datetimeLabel'}>
          {label} {required && <span>*</span>}:{' '}
        </label>
      )}
      <DatePicker
        dateFormat="dd/MM/yyyy"
        selected={startDate}
        onChange={(date: any) => {
          setIsFocus(true);
          setStartDate(date);

          required = true;
          requiredField = true;
          const maxDate = new Date().setFullYear(
            new Date().getFullYear() - _minAge,
          );
          const minDate = new Date().setFullYear(
            new Date().getFullYear() - _maxAge,
          );
          if (!date) {
            error.exist = true;
            error.message = MESSAGE_VALIDATION.requiredField;
            callBack('');
          } else if ((!isScolaire && date >= maxDate) || date < minDate) {
            error.exist = true;
            error.message = `Vous devez être âgé entre ${_minAge} et ${_maxAge} ans`;

            callBack('');
          } else {
            error.exist = false;
            error.message = '';
            callBack(date);
          }
        }}
      />
      {requiredField && error.exist && (
        <Text style={styles.textError}>{error.message}</Text>
      )}
    </div>
  );
};
